import React from "react";

interface ProfilePlaylistsProps {}

const ProfilePlaylists: React.FC<ProfilePlaylistsProps> = () => {
  return <div></div>;
};

export { ProfilePlaylists };
